<template>
  <div>
    <div ref="prescriptionPart" class="prescription-page">
      <lk-form
        ref="prescription"
        :label-width="95"
        :rules='validate'
        :model='info'
      >
        <div>
          <lk-card title="患者信息" class="card">
            <lk-row :gutter='16' v-if="isEdit">
              <lk-col span='8'>
                <lk-form-item label="患者检索:" >
                  <prescriptionSearch  v-if='isEdit' @selected='importPresription' :type="1">
                  </prescriptionSearch >
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='5'>
                <lk-form-item label="患者姓名:" prop="salePrescription.patientName">
                  <lk-input
                    v-if='isEdit && !isIncludes("patientName")'
                    :maxlength='50'
                    placeholder='请输入'
                    v-model="info.salePrescription.patientName"
                  ></lk-input>
                  <span v-else>{{info.salePrescription.patientName}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5'>
                <lk-form-item label="患者性别:" prop="salePrescription.patientGender">
                  <lk-radio-group  v-if='isEdit' v-model="info.salePrescription.patientGender" class="mWidth">
                    <lk-radio v-for="(item,index) in genderList" :label="index*1" :key="index">
                      <span>{{item}}</span>
                    </lk-radio>
                  </lk-radio-group>
                  <span v-else>{{genderList[info.salePrescription.patientGender]}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5'>
                <lk-form-item label="患者年龄:" prop="salePrescription.patientAge">
                  <lk-input
                    :maxlength='4'
                    v-if='isEdit'
                    number
                    placeholder='请输入'
                    v-model="info.salePrescription.patientAge "
                    @on-change='handlerAge($event)'
                  ></lk-input>
                  <span v-else>{{info.salePrescription.patientAge}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5'>
                <lk-form-item label="联系方式:" prop="salePrescription.patientPhone">
                  <lk-input
                    v-if='isEdit && !isIncludes("patientPhone")'
                    :maxlength='50'
                    placeholder='请输入'
                    v-model="info.salePrescription.patientPhone"
                  ></lk-input>
                  <span v-else>{{info.salePrescription.patientPhone}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='5'>
                <lk-form-item label="身份证号:"  prop="salePrescription.patientIdCard" >
                  <lk-input :maxlength='18' placeholder='请输入' v-model="info.salePrescription.patientIdCard"  v-if='isEdit'></lk-input>
                  <span v-else>{{info.salePrescription.patientIdCard}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5'>
                <lk-form-item label="医保类型:" prop="medicalType">
                  <lk-select
                    v-if='isEdit'
                    filterable
                    v-model="info.salePrescription.medicalType"
                    clearable>
                    <lk-option v-for="(item,index) in medicalTypeList" :key="index" :value='index*1'>{{item}}</lk-option>
                  </lk-select>
                  <span v-else>{{medicalTypeList[info.salePrescription.medicalType]}}</span>
                </lk-form-item>
              </lk-col>
               <lk-col span='5'>
                <lk-form-item label="身高(cm):" prop="patientHeight">
                  <NumberInput
                    v-if='isEdit'
                    :maxlength='6'
                    v-model='info.salePrescription.patientHeight'
                    size='default'
                    placeholder="请输入"
                  ></NumberInput>
                  <span v-else>{{info.salePrescription.patientHeight}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5'>
                <lk-form-item label="体重(kg):" prop="patientWeight">
                  <NumberInput
                    v-if='isEdit'
                    :maxlength='6'
                    v-model='info.salePrescription.patientWeight'
                    size='default'
                    placeholder="请输入"
                  ></NumberInput>
                  <span v-else>{{info.salePrescription.patientWeight}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col :span='20'>
                <lk-form-item label='患者地址:'>
                  <div class="editRow" v-if='isEdit'>
                    <location style="width:40%" v-model="info.salePrescription.locationArr" @on-change="changeLocation"></location>
                    <lk-input style="width:60%" v-model="info.salePrescription.address"></lk-input>
                  </div>
                  <div v-else>
                    <span>{{info.salePrescription.locationString}}</span> &nbsp;
                    <span>{{info.salePrescription.address}}</span>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='吸烟量:'>
                <div style="display: flex; width: 100%;">
                  <NumberInput
                    v-if='isEdit'
                    :maxlength='6'
                    v-model='info.diseaseQo.smokingVolume'
                    size='default'
                    style="width: 43%"
                    placeholder="请输入"
                  ></NumberInput>
                  <span v-else>{{info.diseaseQo.smokingVolume || ''}}</span>
                  <span style="width: 36px">包/日</span>
                </div>
                </lk-form-item>
              </lk-col>
              <lk-col span='10'>
                <lk-form-item label='饮酒量:'>
                <div style="display: flex">
                  <NumberInput
                    v-if='isEdit'
                    :maxlength='6'
                    v-model='info.diseaseQo.drinkingVolume'
                    size='default'
                    style="width: 43%"
                    placeholder="请输入"
                  ></NumberInput>
                  <span v-else>{{info.diseaseQo.drinkingVolume || ''}}</span>
                  <span style="width: 36px">两/日</span>
                </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='既往病史:'>
                  <lk-radio-group v-model="info.diseaseQo.diseaseHistory" v-if="isEdit">
                    <lk-radio :label='1'>有</lk-radio>
                    <lk-radio :label='2'>无</lk-radio>
                  </lk-radio-group>
                  <span v-else>{{selectList[info.diseaseQo.diseaseHistory]}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16' v-if="info.diseaseQo.diseaseHistory===1">
                <lk-col span='20'>
                  <lk-form-item label=''>
                    <div class="historyInput">
                      <lk-input placeholder='请输入' :maxlength='500' type="textarea" v-model.trim="info.diseaseQo.diseaseHistoryDetail" clearable :disabled='!this.isEdit && info.diseaseQo.diseaseHistory === 1'></lk-input>
                    </div>
                  </lk-form-item>
                </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='过敏史:'>
                  <lk-radio-group v-model="info.diseaseQo.foodAllergyHistory" v-if="isEdit">
                    <lk-radio :label='1'>有</lk-radio>
                    <lk-radio :label='2'>无</lk-radio>
                  </lk-radio-group>
                  <span v-else>{{selectList[info.diseaseQo.foodAllergyHistory]}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16' v-if="info.diseaseQo.foodAllergyHistory===1">
                <lk-col span='20'>
                  <lk-form-item label=''>
                    <div class="historyInput">
                      <lk-input placeholder='请输入' :maxlength='500' type="textarea" v-model.trim="info.diseaseQo.foodAllergyHistoryDetail"  clearable :disabled='!this.isEdit && info.diseaseQo.foodAllergyHistory === 1'></lk-input>
                    </div>
                  </lk-form-item>
                </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='家族遗传病史:'>
                  <lk-radio-group v-model="info.diseaseQo.familyHistory" v-if="isEdit">
                    <lk-radio :label='1'>有</lk-radio>
                    <lk-radio :label='2'>无</lk-radio>
                  </lk-radio-group>
                  <span v-else>{{selectList[info.diseaseQo.familyHistory]}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16' v-if="info.diseaseQo.familyHistory===1">
              <lk-col span='20'>
                <lk-form-item label=''>
                  <div class="historyInput">
                    <lk-input placeholder='请输入' :maxlength='500' type="textarea" v-model.trim="info.diseaseQo.familyHistoryDetail" clearable :disabled='!this.isEdit && info.diseaseQo.familyHistory === 1'></lk-input>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='20'>
                <lk-form-item label='其他用药:'>
                  <lk-input v-if="isEdit" placeholder='除购买的药品以外，当前所用其他药物使用情况（如：处方药、非处方药、中药、保健品等）' :maxlength='50000' v-model.trim="info.diseaseQo.otherDrugs" clearable></lk-input>
                  <span v-else>{{info.diseaseQo.otherDrugs}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-card>
          <lk-card title="处方信息" class="card">
            <lk-row :gutter='16'>
              <lk-col span='5'>
                <lk-form-item label="处方日期:" prop="salePrescription.prescriptionTime">
                  <timeStampDatePicker
                    style="width:100%"
                    placeholder='请选择'
                    v-if='isEdit'
                    v-model="info.salePrescription.prescriptionTime"
                    :options="options"
                  ></timeStampDatePicker>
                  <span v-else>{{info.salePrescription.prescriptionTime|formatDate}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5'>
                <lk-form-item label="处方医生:" prop="salePrescription.prescriptionDoctor"
                  >
                  <lk-auto-complete
                    v-if="isEdit"
                    :clearable='true'
                    :maxlength="30"
                    v-model="info.salePrescription.prescriptionDoctor"
                    @on-change="handleSearch1"
                    @on-select='handleSelect'
                    @on-focus='handleFoucus'
                    placeholder="可通过医生姓名搜索"
                    >
                    <div class="test1" v-if='doctorList'>
                      <lk-option
                      v-for="(item,index) in doctorList"
                      :value="item.doctorCode"
                      :key="index"
                      >{{`${item.doctorName}-${item.hospitalName}`}}</lk-option>
                    </div>
                    <div v-else>
                        <div v-if="isEmpty" class="nodata">
                          暂无数据
                        </div>
                      </div>
                  </lk-auto-complete>

                  <span v-else>{{info.salePrescription.prescriptionDoctor}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5'>
                <lk-form-item class="test" label="处方医院:" prop="salePrescription.prescriptionHospital">
                  <prescriptionHospital v-if='isEdit' :maxlength='100'  placeholder='请输入'
                    v-model="info.salePrescription.prescriptionHospital "></prescriptionHospital>
                  <span v-else>{{info.salePrescription.prescriptionHospital}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5' >
                <lk-form-item label="处方科室:" prop="hospitalDept">
                  <lk-input v-if='isEdit' :maxlength='100' placeholder='请输入'
                    v-model="info.salePrescription.hospitalDept "></lk-input>
                  <span v-else>{{info.salePrescription.hospitalDept}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='5'>
                <lk-form-item label="处方诊断:" prop="salePrescription.diseaseId">
                  <lk-select
                    v-if='isEdit'
                    filterable
                    v-model="info.salePrescription.diseaseId"
                    @on-change='setAdditionalRemark'
                    clearable>
                    <lk-option v-for="(item,index) in diseaseList" :key="index" :value='item.id'>{{item.diseaseName}}</lk-option>
                  </lk-select>
                  <span v-else>{{info.salePrescription.diseaseName}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5'>
                <lk-form-item
                  label="诊断补充说明:"
                  prop="salePrescription.additionalRemark"
                  :class="{'ivu-form-item-required': info.salePrescription.diseaseName==='其他'}"
                >
                  <lk-input v-if='isEdit' :maxlength='100' placeholder='请输入'
                    v-model="info.salePrescription.additionalRemark "></lk-input>
                  <span v-else>{{info.salePrescription.additionalRemark}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5'>
                <lk-form-item label="体征:" prop="patientSign">
                  <lk-input v-if='isEdit' :maxlength='500'  placeholder='请输入'
                    v-model="info.salePrescription.patientSign "></lk-input>
                  <span v-else>{{info.salePrescription.patientSign}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='5'>
                <lk-form-item label='检查结果:'>
                  <lk-input v-if='isEdit' :maxlength='500' placeholder='请输入'
                    v-model="info.salePrescription.inspectionResults "></lk-input>
                  <span v-else>{{info.salePrescription.inspectionResults}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="5">
                <lk-form-item label="检测报告">
                  <Uploader
                    v-model.trim='info.salePrescription.inspectionCardUrl'
                    :maxSize='10'
                    :able='isEdit'
                    :format='format'
                    style="width: 100%"
                  ></Uploader>
                </lk-form-item>
              </lk-col>
              <lk-col span="5">
                <lk-form-item label="处方图片">
                  <Uploader
                    v-model.trim='info.salePrescription.picUrl'
                    :maxSize='10'
                    :able='isEdit'
                    :format='format'
                    style="width: 100%"
                  ></Uploader>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-card>
          <lk-card title="药品信息">
            <lk-table border :columns="columns" :data="info.saleUsageList"></lk-table>
          </lk-card>
        </div>
      </lk-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import timeStampDatePicker from '../timeStampDatePicker.vue';
import utils from '../../libs/utils.js';
import prescriptionSearch from './PatientSearch.vue';
import prescriptionHospital from './PrescriptionHospital.vue';
import goods from '../../services/goods';
import Uploader from '../Uploader.vue';
import location from '../location.vue';

export default {
  name: 'CareInfo',
  components: {
    timeStampDatePicker,
    prescriptionSearch,
    Uploader,
    prescriptionHospital,
    location,
  },
  props: {
    isEdit: {
      type: Boolean,
    },
    diseaseList: {
      type: Array,
    },
    careInfo: {
      type: Object,
    },
    sourceType: {},
  },
  model: {
    prop: 'careInfo',
    event: 'change',
  },
  computed: {
    ...mapState({
      publicParams: state => state.publicParams,
    }),
  },
  watch: {
  },
  data() {
    return {
      options: {
        disabledDate: utils.forbiddenDate.disabledFromToday,
      },
      YLEditList: [], // 药联不可编辑的字段集合
      tempTableData: [],
      baseData: [], // 用法用量
      selectList: {
        1: '有',
        2: '无',
      },
      selectList1: {
        1: '正常',
        2: '损害',
      },
      format: [
        'image/png',
        'image/jpeg',
        'jpg', 'jpeg', 'gif', 'png', 'tiff', 'bmp',
        'application/pdf',
        'pdf',
      ],
      columns: [
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
        },
        {
          title: '数量',
          key: 'goodsCount',
          minWidth: 144,
        },
        {
          title: '用法',
          key: 'goodsUsageType',
          minWidth: 144,
          renderHeader: (h, params) => this.renderHeader(h, params, '用法'),
          render: (h, params) => {
            const optionArr = this.baseData.usageArr.map(item => h('lk-option', {
              props: {
                value: item.dictionaryIndex,
              },
            }, item.dictionaryName));
            return this.isEdit ? h('lk-select',
              {
                props: {
                  value: params.row.goodsUsageType || '',
                  placeholder: '请选择',
                  transfer: true,
                },
                on: {
                  'on-change': (value) => {
                    this.handlerChange(params.index, 'goodsUsageType', value);
                  },
                },
              },
              optionArr) : h('span', params.row.goodsUsage);
          },
        },
        {
          title: '频次',
          key: 'frequency',
          minWidth: 144,
          renderHeader: (h, params) => this.renderHeader(h, params, '频次'),
          render: (h, params) => {
            const optionArr = this.baseData.frequencyArr.map(item => h('lk-option', {
              props: {
                value: item.dictionaryIndex,
              },
            }, item.dictionaryName));
            return this.isEdit ? h('lk-select',
              {
                props: {
                  value: params.row.frequency || '',
                  placeholder: '请选择',
                  transfer: true,
                },
                on: {
                  'on-change': (value) => {
                    this.handlerChange(params.index, 'frequency', value);
                  },
                },
              },
              optionArr) : h('span', params.row.frequencyName);
          },
        },
        {
          title: '每次用量',
          key: 'goodsDosage',
          minWidth: 144,
          renderHeader: (h, params) => this.renderHeader(h, params, '每次用量'),
          render: (h, params) => (this.isEdit ? h('lk-input',
            {
              props: {
                value: params.row.goodsDosage || '',
                placeholder: '',
                maxlength: 100,
              },
              on: {
                'on-blur': (e) => {
                  this.handlerChange(params.index, 'goodsDosage', e.target.value);
                },
              },
            }) : h('span', params.row.goodsDosage)),
        },
        {
          title: '开始用药时间',
          key: 'usageStartTime',
          minWidth: 144,
          render: (h, params) => (this.isEdit ? h('timeStampDatePicker', {
            on: {
              'on-change': (value) => {
                this.handlerChange(params.index, 'usageStartTime', value);
              },
            },
            props: {
              value: params.row.usageStartTime || '',
            },
          }) : h('span', utils.formatDate(params.row.usageStartTime))),
        },
        {
          title: '用药周期',
          key: 'medicationCycle',
          minWidth: 144,
          render: (h, params) => (this.isEdit ? h('NumberInput', {
            on: {
              'on-blur': (e) => {
                this.handlerChange(params.index, 'medicationCycle', e);
              },
            },
            props: {
              type: 'int',
              maxlength: 9,
              size: 'default',
              value: params.row.medicationCycle || '',
            },
          }) : h('span', params.row.medicationCycle)),
        },
      ],
      valid: false,
      tableData: [],
      saleUsageList: [], // 处方商品
      validate: {
        'salePrescription.prescriptionTime': [{
          required: true,
          message: '请选择处方日期',
          type: 'date',
        }],
        'salePrescription.patientPhone': [{
          required: true,
          message: '请输入联系方式',
          trigger: 'change',
        },
        {
          validator: utils.validate.phoneValidator,
          message: '请输入正确联系方式',
          trigger: 'blur',
        },
        ],
        'salePrescription.patientName': [{
          required: true,
          message: '请输入患者姓名',
          trigger: 'change',
        }],
        'salePrescription.prescriptionDoctor': [{
          required: true,
          message: '请输入处方医生',
          trigger: 'blur',
        }],
        'salePrescription.prescriptionHospital': [{
          required: true,
          message: '请输入处方医院',
          trigger: 'blur',
        }],
        'salePrescription.diseaseId': [{
          required: true,
          message: '请选择诊断说明',
          trigger: 'change',
          type: 'number',
        }],
        'salePrescription.patientAge': [{
          required: true,
          message: '请填写年龄',
          trigger: 'change',
          type: 'number',
        }],
        'salePrescription.patientGender': [{
          required: true,
          type: 'number',
          message: '请选择性别',
        }],
        'salePrescription.patientIdCard': [
          {
            validator: utils.validate.IDValidator,
            trigger: 'blur',
          },
        ],
      },
      doctorList: [],
      genderList: {
        1: '男',
        2: '女',
      },
      medicalTypeList: {
        1: '本省市医保',
        2: '外省市医保',
        3: '自费',
      },
      type: '',
      isEmpty: false,
      pharmacistList: [],
      info: {
        salePrescription: {},
        diseaseQo: {},
      },
    };
  },
  methods: {
    changeLocation(val) {
      if (val) {
        this.info.salePrescription.provinceId = val[0];
        this.info.salePrescription.cityId = val[1];
        this.info.salePrescription.countyId = val[2];
        delete this.info.salePrescription.provinceName;
        delete this.info.salePrescription.cityName;
        delete this.info.salePrescription.countyName;
      }
    },
    isIncludes(key) {
      return this.YLEditList.includes(key);
    },
    renderHeader(h, params, title) {
      return h('div', [
        h('span', {
          style: {
            marginRight: '4px',
            lineHeight: 1,
            fontFamily: 'SimSun',
            fontSize: '12px',
            color: '#ed4014',
          },
        }, '*'),
        h('span', title),
      ]);
    },
    exchangeDictionary(arr, index) {
      return utils.exchangeDictionary(arr, index);
    },
    handlerChange(index, str, val) {
      switch (str) {
        case 'frequency':
          this.$set(this.info.saleUsageList[index], 'frequencyName', this.exchangeDictionary(this.baseData.frequencyArr, val));
          break;
        case 'goodsUsageType':
          this.$set(this.info.saleUsageList[index], 'goodsUsage', this.exchangeDictionary(this.baseData.usageArr, val));
          break;
        default:
          break;
      }
      this.$set(this.info.saleUsageList[index], str, val);
    },
    handlerAge(e) {
      const age = Number(e.target.value.replace(/\D/g, ''));
      if (age < 0 || age > 130) {
        this.$Message.warning('请输入0-130之间的数字');
        this.info.salePrescription.patientAge = '';
      }
    },
    validateForm() {
      this.$emit('change', this.info);
      return new Promise((resolve) => {
        this.$refs.prescription.validate((valid) => {
          resolve(valid);
        });
      });
    },
    handleFoucus() {
      this.isEmpty = false;
    },
    handleSelect(value) {
      this.selectStatus = true;
      this.doctorList.forEach((item) => {
        if (item.doctorCode == value) {
          this.$nextTick(() => {
            this.info.salePrescription.prescriptionDoctor = item.doctorName;
            this.info.salePrescription.prescriptionHospital = item.hospitalName;
            this.info.salePrescription.hospitalDept = item.deptName;
            this.doctorList = [];
          });
        }
      });
    },
    handleSearch1: utils.debounce(
      function a(value) {
        if (this.selectStatus) {
          this.selectStatus = false;
          return;
        }
        if (!value) {
          this.isEmpty = false;
          return;
        }
        this.isEmpty = false;
        this.info.prescriptionDoctorId = '';
        this.doctorList = [];
        this.$store.commit('setDisableLoading', true);
        goods.getDoctorList({ param: value }).then((res) => {
          if (res.status === 200) {
            this.doctorList = res.data.data;
            if (!this.doctorList) {
              this.isEmpty = true;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }, 2000,
    ),
    setAdditionalRemark() {
      this.info.salePrescription.diseaseName = (this.diseaseList.length && this.info.salePrescription.diseaseId) ? this.diseaseList.find(item => item.id === this.info.salePrescription.diseaseId).diseaseName : '';
      if (this.info.salePrescription.diseaseName === '其他') {
        this.validate['salePrescription.additionalRemark'] = [{ required: true, message: '请输入诊断补充说明', trigger: 'change' }];
      } else {
        this.validate['salePrescription.additionalRemark'] = [{ required: false }];
        this.diseaseList.length && this.$nextTick(() => {
          this.$refs.prescription.validateField('salePrescription.additionalRemark', () => {});
        });
      }
    },
    importPresription(data) {
      const salePrescription = data.salePrescription;
      const {
        patientAge,
        patientHeight,
        patientIdCard,
        patientName,
        patientPhone,
        patientSign,
        patientWeight,
      } = salePrescription;
      Object.assign(this.info.salePrescription, {
        patientAge,
        patientHeight,
        patientIdCard,
        patientName,
        patientPhone,
        patientSign,
        patientWeight,
      });
    },
    getBaseData() { // 获取用法用量
      return new Promise((resolve) => {
        goods.GoodsDictionary().then((res) => {
          if (res.data.status === 200) {
            this.baseData.usageArr = [];
            this.baseData.frequencyArr = [];
            res.data.data.forEach((item) => {
              switch (item.dictionaryType) {
                case 14:
                  this.baseData.usageArr.push(item);
                  break;
                case 15:
                  this.baseData.frequencyArr.push(item);
                  break;

                default:
                  break;
              }
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
  },
  created() {
  },
  mounted() {
    this.getBaseData().then(() => {
      this.info = this.careInfo;
      this.publicParams.PCEditList.forEach((item) => {
        // 药联订单，患者姓名，联系方式不可编辑
        if (this.sourceType == 9) {
          !this.info[item] && this.YLEditList.push(item);
        }
      });
      this.setAdditionalRemark();
    }).catch((err) => {
      utils.handleError(err);
    });
  },
};
</script>

<style lang="less" scoped>

.prescription-page {
  .patientTite {
    font-weight: 500;
    margin-left: 29px;
  }
  .mWidth {
    min-width: 132px;
  }
}
.card {
  margin-bottom: 20px;
}
.test1 {
  position: relative;
  overflow: auto;
  min-height: 0;
  max-height: 100px;
  /deep/ .ivu-select-item  {
    width:220px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.test {
  /deep/ .ivu-select-item  {
    width:220px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
/deep/ .ivu-select-dropdown {
  z-index: 999;
  padding: 0;
}
.nodata {
  color: #9a9a9a;
  font-size: 14px;
  padding: 4px 0 4px 4px;
}
#app .ivu-radio-wrapper {
  margin-right: 20px;
}
.editRow{
  display: flex;
  justify-content: space-between;
  // margin-bottom: 8px;
  >*:first-child{
    width: 90%;
    >*{

      width: 33%;
    }
  }
}
</style>
